__turbopack_context__.v({
  "login": "HeaderLogin-module-scss-module__fpfjEq__login",
  "loginMenu": "HeaderLogin-module-scss-module__fpfjEq__loginMenu",
  "toggle": "HeaderLogin-module-scss-module__fpfjEq__toggle",
  "visuallyHidden": "HeaderLogin-module-scss-module__fpfjEq__visuallyHidden",
});
